import { render, staticRenderFns } from "./detailed_info.vue?vue&type=template&id=1cead3cc&"
import script from "./detailed_info.vue?vue&type=script&lang=js&"
export * from "./detailed_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports